import { normalize } from 'normalizr'
import qs from 'query-string'
import { get } from '../../utilities/api'
import * as t from './actionTypes'
import { calculateDepartureDate } from './utilities'
import { setEntities } from '../../actions/entityActions'

import {
  accommodationtypeSchema,
  countrySchema,
  objectSchema,
  resortSchema,
  resourceadditionSchema,
  sourceSchema,
  subjectSchema,
  propertyGroupSchema
} from './schemas'
import { getAccommodationTypes } from '../../api/accommodationTypeApi'

export const setBooking = (bookingType, payload) => ({
  type: t.SET_BOOKING,
  bookingType,
  payload
})

export const setIsLoading = payload => ({
  type: t.SET_IS_LOADING,
  payload
})

export const fetchAccommodationType = id => (dispatch, getState) => get({
  url: `/accommodationtypes/${id}`,
  params: {
    locale: getState().preferences.locale
  }
})
  .then(({ data }) => {
    const normalized = normalize(data, accommodationtypeSchema)
    return dispatch(setEntities(normalized.entities))
  })

let fetchAccommodationTypesPromise = null
export const fetchAccommodationTypes = () => (dispatch, getState) => {
  if (fetchAccommodationTypesPromise) return fetchAccommodationTypesPromise

  fetchAccommodationTypesPromise = getAccommodationTypes({ locale: getState().preferences.locale })
    .then(({ data }) => {
      const normalized = normalize(data, [accommodationtypeSchema])
      dispatch(setEntities(normalized.entities))
      fetchAccommodationTypesPromise = null
      return data
    })

  return fetchAccommodationTypesPromise
}

export const fetchPropertyGroups = () => (dispatch, getState) => get({
  url: '/propertygroups',
  params: { locale: getState().preferences.locale }
})
  .then(({ data }) => {
    const normalized = normalize(data, [propertyGroupSchema])
    dispatch(setEntities(normalized.entities))
  })

export const fetchSubjects = () => (dispatch, getState) => get({
  url: '/subjects',
  params: { locale: getState().preferences.locale }
})
  .then(({ data }) => {
    const normalized = normalize(data, [subjectSchema])
    return dispatch(setEntities(normalized.entities))
  })

export const getCountries = () => (dispatch, getState) => get({
  url: '/countries',
  params: { locale: getState().preferences.locale }
})
  .then(({ data }) => {
    const normalized = normalize(data, [countrySchema])
    dispatch(setBooking('countries', normalized.entities.countries))
  })

export const getObjects = () => dispatch => get({ url: '/objects' })
  .then(({ data }) => {
    const normalized = normalize(data, [objectSchema])
    dispatch(setBooking('objects', normalized.entities.objects))
  })

export const getObjectsNames = () => dispatch => get({ url: '/objects/names' })
  .then(({ data }) => {
    const normalized = normalize(data, [objectSchema])
    dispatch(setEntities(normalized))
  })

export const getResorts = () => dispatch => get({ url: '/resorts' })
  .then(({ data }) => {
    const normalized = normalize(data, [resortSchema])
    dispatch(setEntities(normalized))
  })

export const getSources = () => dispatch => get({ url: '/sources' })
  .then(({ data }) => {
    const normalized = normalize(data, [sourceSchema])
    dispatch(setEntities(normalized))
  })

export const getResourceAdditions = (resource, arrival, duration) => (dispatch, getState) => get({
  url: '/resourceadditions',
  params: {
    locale: getState().preferences.locale,
    resource_id: resource,
    departure: calculateDepartureDate(arrival, duration),
    arrival,
    subjects: (() => {
      const { subjects } = getState().preferences
      return Object.keys(subjects)
        .filter(i => subjects[i] > 0)
        .map(i => `${i}-${subjects[i]}`)
    })()
  }
}).then(({ data }) => {
  const normalized = normalize(data, [resourceadditionSchema])
  dispatch(setBooking('resourceadditions', normalized.entities.resourceadditions))
})

export const createMoreInfoUrl = moreInfoUrlObject => qs.stringify(moreInfoUrlObject, { arrayFormat: 'brackets' })
